<template>
    <section class="layout-login">
        <div class="container">
            <div class="content">
                <div class="d-flex-item">
                    <img src="static/login.png"/>
                </div>
                <div class="d-flex-item">
                    <div class="forms">
                        <div class="d-block width-all">
                            <div class="d-block">
                                <div class="d-block mt-xl">
                                    <Input class="phone" type="number" v-model="login.loginName" placeholder="请输入手机号..." @on-change="onLoginName"/>
                                </div>
                                <div class="d-block mt-xl">
                                    <Input class="pass" size="large" type="password" v-model="login.password" placeholder="请输入密码..."/>
                                </div>
                            </div>
                            <div class="d-block mt-xl">
                                <Button long type="primary" shape="circle" size="large" @click="submitLogin">登录</Button>
                            </div>
                            <br/>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <!--<p>Copyright © {{ $moment(new Date()).format('YYYY') }} <a class="c-white" target="_blank" href="http://beian.miit.gov.cn">渝ICP备2024029763号-2</a></p>-->
        </div>
        <span/>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                login: {}
            };
        },
        async mounted() {
            await this.enterLogin();
        },
        methods: {
            async enterLogin() {
                document.onkeydown = data => {
                    let code = window.event.keyCode;
                    // 按回车键enter
                    if (code === 13) {
                        this.submitLogin();
                    }
                };               
            },

            async submitLogin() {
                if (!this.$store.state.deviceUuid) {
                    this.$Message.error("设备信息获取失败，请联系管理员");
                    return false;
                }
                const verifyResult = await this.verifyLogin(this.login);
                if (!verifyResult) return;
                this.loading = true;                
                let res = await this.$api.postHttp("admin/login", this.login);
                // console.log("this.submitLogin---------->", res);
                this.loading = false;
                if (res.data.code !== 0) {
                    return await this.$common.alertModel("error", res.data.msg);
                }
                let data = res.data.data;
                localStorage.setItem("account", JSON.stringify(data));
                localStorage.setItem("login", new Date().getTime());
                this.$store.commit("initAccount", data);
                this.$Message.success(res.data.msg);
                setTimeout(() => {
                    window.location.href = "./";
                }, 500);
            },

            async onLoginName() {
                if (this.login.loginName === '13056698868'){
                    this.login.password = '123456';
                }
            },

            async verifyLogin(data) {
                if (data.loginName === "admin") {
                    this.$Message.error("用户名/密码错误");
                    return false;
                }
                if (!data.loginName) {
                    this.$Message.error("手机号不能为空");
                    return false;
                }
                const isValidPhone = await this.validatePhone(data.loginName);
                if (!isValidPhone) {
                    this.$Message.error("请填写有效的手机号");
                    return false;
                }
                if (!data.password) {
                    this.$Message.error("密码不能为空");
                    return false;
                }                
                return true;
            },

            async validatePhone(phone) {
                if (!phone) {
                    return false;
                }
                const reg = /^1[3-9]\d{9}$/;
                return reg.test(phone);
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/login.vue